import { Skeleton } from 'antd'
import { styled } from 'styled-components'
export const MapSkeleton = styled(Skeleton.Image).attrs({
  // this height and width set the bounding height/width
  style: {
    height: '100%',
    width: '100%',
  },
  active: true,
})`
  // this height and width set the 'active' animation container height/width
  height: 100%;
  width: 100%;
  min-width: 100%;
  min-height: 100%;
`
